<template>
    <div id="app" :class="appClassObject">
        <ion-app>
            <!-- Listen to before and after tab change events -->
            <ion-tabs ref="tabs" @IonTabsWillChange="ionTabsWillChange">
                <ion-tab tab="/dashboard" :routes="['dashboard']">
                    <ion-vue-router
                        name="dashboard"
                        :animated="false"
                    ></ion-vue-router>
                </ion-tab>
                <ion-tab tab="/vertraege" :routes="['vertraege']">
                    <ion-vue-router
                        name="vertraege"
                        :animated="false"
                    ></ion-vue-router>
                </ion-tab>
                <ion-tab tab="/nachrichten" :routes="['nachrichten']">
                    <ion-vue-router
                        name="nachrichten"
                        :animated="false"
                    ></ion-vue-router>
                </ion-tab>
                <ion-tab tab="/menu" :routes="['menu']">
                    <ion-vue-router
                        name="menu"
                        :animated="false"
                    ></ion-vue-router>
                </ion-tab>

                <ion-tab
                    tab="/default"
                    :routes="[
                        'login',
                        'aktivierung',
                        'vertrag',
                        'vertragsdetails',
                        'umsaetze',
                        'einzahlung',
                        'anpassen',
                        'uebersicht',
                        'auszahlung',
                        'spontanrueckzahlung',
                        'kreditcheckliste',
                        'schadensmeldung',
                        'schadensmeldung-neu',
                        'schadensmeldung-kfz',
                        'schadensmeldung-kfz-neu',
                        'schadensmeldung-haushalt',
                        'schadensmeldung-haushalt-neu',
                        'schadensmeldung-sach',
                        'schadensmeldung-sach-neu',
                        'schadensmeldung-recht',
                        'schadensmeldung-recht-neu',
                        'schadensmeldung-krankenhaus',
                        'schadensmeldung-unfall',
                        'motive-schadensmeldung',
                        'motive-schadensmeldung-kfz',
                        'motive-schadensmeldung-haushalt',
                        'motive-schadensmeldung-sach',
                        'motive-schadensmeldung-recht',
                        'profil',
                        'einstellungen',
                        'hilfe',
                        'motiv',
                        'berater',
                        'beraterdetails',
                        'motive-beraterdetails',
                        'unwetterwarnung',
                        'fonds',
                        'services',
                        'dokbox',
                        'services-unwetterwarnung',
                        'services-unwetterwarnung-neu',
                        'biketrax',
                        'services-biketrax',
                        // 'immowert',
                        'gutschein',
                        'video-termin',
                        'video-termin-abschluss',
                        'video-meeting',
                        'protected',
                        // 'services-schmerzlinderung',
                        'my21',
                        'my21-day',
                        'me1ns',
                        'me1nzuhause',
                        'me1nzuhause-vortrag',
                        'kfz-begutachtung',
                        'sepa-lastschrift',
                        'bestfit',
                        'page-not-found',
                    ]"
                >
                    <ion-vue-router :key="$route.fullPath"></ion-vue-router>
                </ion-tab>

                <template
                    v-slot:bottom
                    v-if="isLoggedIn && $store.state.showTabBar"
                >
                    <ion-tab-bar>
                        <ion-tab-button tab="/dashboard">
                            <!-- <ion-icon name="home"></ion-icon> -->
                            <span class="icon-navi_dashboard"></span>
                            <ion-label>Home</ion-label>
                        </ion-tab-button>
                        <ion-tab-button tab="/vertraege">
                            <!-- <ion-icon name="copy"></ion-icon> -->
                            <span class="icon-navi_vertraege"></span>
                            <ion-label>Produkte</ion-label>
                        </ion-tab-button>
                        <ion-tab-button
                            tab="/aktion"
                            @click="presentActionSheet()"
                            class="-add-button"
                        >
                            <ion-icon name="add"></ion-icon>
                            <!-- <span class="icon-navi_multi_button"></span> -->
                        </ion-tab-button>
                        <ion-tab-button tab="/nachrichten">
                            <!-- <ion-icon name="mail"></ion-icon> -->
                            <ion-badge v-if="messageCount > 0">{{
                                messageCount
                            }}</ion-badge>
                            <span class="icon-navi_nachrichten"></span>
                            <ion-label>Postbox</ion-label>
                            <!-- <ion-badge>1</ion-badge> -->
                        </ion-tab-button>
                        <ion-tab-button tab="/menu">
                            <!-- <ion-icon name="menu"></ion-icon> -->
                            <span class="icon-navi_menu"></span>
                            <ion-label>Menü</ion-label>
                        </ion-tab-button>
                    </ion-tab-bar>
                </template>
            </ion-tabs>
            <dokbox-gallery slot="fixed"></dokbox-gallery>
        </ion-app>
    </div>
</template>

<script>
import { checkAppVersion } from "@/api/version";
import { isLoggedIn, logout } from "@/api/auth";
import { IsMaintenance } from "@/api/maintenance";
import DokboxModal from "@/components/DokboxModal";
import { Plugins, Capacitor } from "@capacitor/core";
import DokboxGallery from "@/components/DokboxGallery";
import { handleError } from "@/utils/error";
import { isPageLoggedOutAllowed } from "@/utils";
import { getContracts } from "@/api/contracts";
import { getChecklists } from "@/api/kreditcheckliste";
import storage from "@/utils/storage";
import { IsMaintenanceApp } from "./api/maintenance";
import MaintenanceModal from "./components/MaintenanceModal.vue";

const {
    // UrbanAirshipPlugin,
    Browser,
    SplashScreen,
    App,
    Keyboard,
    Storage,
    PushNotifications,
} = Plugins;

export default {
    components: {
        DokboxGallery,
    },
    data() {
        return {
            loadingInstances: [],
            hostname: window.location.hostname,
        };
    },
    mounted() {
        SplashScreen.hide();
        App.addListener("appUrlOpen", (data) => {
            // Example url: https://beerswift.app/tabs/tab2
            // slug = /tabs/tab2
            const url = data.url;
            const slug = url.split("#").pop();
            if (url.includes("#") && slug) {
                this.$router.push(slug);
            }
            // If no match, do nothing - let regular routing
            // logic take over
        });

        if (Capacitor.isNative) {
            logout(false);
            Keyboard.setAccessoryBarVisible({ isVisible: true });
            App.addListener("appStateChange", (state) => {
                // state.isActive contains the active state
                // login check fixes faceid bug
                if (state.isActive) {
                    sessionStorage.removeItem("csrftoken");
                    if (this.$route.name !== "login" && this.isLoggedIn) {
                        isLoggedIn().catch(() => {
                            if (!isPageLoggedOutAllowed(this.$route.name)) {
                                logout();
                            }
                        });
                    }
                }
            });
            this.setupPushNotifications();
        }

        checkAppVersion();

        IsMaintenance().then((response) => {
            if (
                response.data.Status === 200 &&
                Object.keys(response.data.Result).length > 0 &&
                response.data.Result.Text !== ""
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message: response.data.Result.Text,
                        buttons: ["Ok"],
                    })
                    .then((a) => {
                        // a.onDidDismiss().then(() => {
                        //   this.$store.commit("setError", false);
                        // });
                        a.present();
                    });
            }
        });

        IsMaintenanceApp().then((response) => {
            if (
                !this.$route.name.startsWith("schadensmeldung") &&
                response.data.Status === 200 &&
                Object.keys(response.data.Result).length > 0 &&
                response.data.Result.Text !== ""
            ) {
                this.$ionic.modalController
                    .create({
                        component: MaintenanceModal,
                        componentProps: {
                            propsData: {
                                content: response.data.Result.Text,
                            },
                        },
                        backdropDismiss: false,
                    })
                    .then((m) => {
                        m.present();
                    });
                // this.$ionic.alertController
                //     .create({
                //         header: "Bitte beachten",
                //         message: response.data.Result.Text,
                //         buttons: ["Ok"],
                //     })
                //     .then((a) => {
                //         a.present();
                //     });
            }
        });
    },
    watch: {
        loading(value) {
            if (value) {
                this.$ionic.loadingController
                    .create({
                        message: "",
                        duration: this.$store.state.loadingSpinnerDuration,
                        cssClass: "c-loading",
                    })
                    .then((l) => {
                        if (this.loading) {
                            this.loadingInstances.push(l);
                            l.present();
                            l.onDidDismiss().then(() => {
                                this.$store.commit("setLoading", false);
                            });
                        } else {
                            l.dismiss();
                        }
                    });
            } else if (this.loadingInstances.length > 0) {
                this.dismissAllLoadingInstances();
            } else {
                setTimeout(() => {
                    this.dismissAllLoadingInstances();
                }, 3000);
            }
            // if (value) {
            //   this.$ionic.loadingController
            //     .create({
            //       message: "",
            //       duration: 60 * 1000
            //     })
            //     .then(l => {
            //       if (this.loading) {
            //         l.present();
            //       } else {
            //         l.dismiss();
            //       }
            //     })
            //     .catch(error => {
            //       handleError(error);
            //     });
            // } else {
            //   this.dismissAllLoadings();
            // }
        },
        error(value) {
            if (value) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message: this.$store.state.errorMessage,
                        buttons: ["Ok"],
                    })
                    .then((a) => {
                        a.onDidDismiss().then(() => {
                            this.$store.commit("setError", false);
                        });
                        a.present();
                    });
            }
        },
        isLoggedIn(value) {
            if (value) {
                this.$store.dispatch("postbox/getPostBoxEntries");

                // Check if contracts and checklists are empty and fetch them if so
                storage.setStoreData().then(() => {
                    if (Object.keys(this.$store.state.contracts).length === 0) {
                        getContracts().then((response) => {
                            if (response.data.Status === 200) {
                                Storage.set({
                                    key: "contracts",
                                    value: JSON.stringify(
                                        response.data.Result.vertraege
                                    ),
                                });
                                this.$store.commit(
                                    "setContracts",
                                    response.data.Result.vertraege
                                );
                            }
                        });
                    }
                    if (
                        Object.keys(this.$store.state.checklists).length === 0
                    ) {
                        getChecklists().then((response) => {
                            if (response.data.Status === 200) {
                                Storage.set({
                                    key: "checklists",
                                    value: JSON.stringify(response.data.Result),
                                });
                                this.$store.commit(
                                    "setChecklists",
                                    response.data.Result
                                );
                                this.$store.commit(
                                    "kreditcheckliste/setChecklists",
                                    response.data.Result
                                );
                            }
                        });
                    }
                });
            }
        },
        askForRating(value) {
            // App Rating
            Storage.get({ key: "neveraskforrating" }).then(
                ({ value: neveraskforratingVal }) => {
                    if (
                        neveraskforratingVal !== "true" &&
                        value &&
                        Capacitor.isNative
                    ) {
                        if (Capacitor.platform === "android") {
                            this.$ionic.alertController
                                .create({
                                    header: "Gefällt dir Wüstenrot?",
                                    message:
                                        "Wir freuen uns über jedes Feedback. Würdest du uns gerne im Play Store bewerten?",
                                    buttons: [
                                        {
                                            text: "Nein danke",
                                            handler: () => {
                                                Storage.set({
                                                    key: "neveraskforrating",
                                                    value: "true",
                                                });
                                            },
                                        },
                                        {
                                            text: "Später",
                                            role: "cancel",
                                        },
                                        {
                                            text: "Jetzt bewerten",
                                            handler: () => {
                                                Storage.set({
                                                    key: "neveraskforrating",
                                                    value: "true",
                                                });
                                                Plugins.CapacitorRateApp.requestReview();
                                            },
                                        },
                                    ],
                                })
                                .then((a) => {
                                    a.present();
                                });
                        } else if (Capacitor.platform === "ios") {
                            Plugins.CapacitorRateApp.requestReview();
                        }
                    }
                }
            );
            this.$store.commit("setAskForRating", false);
        },
    },
    computed: {
        appClassObject() {
            let result = {};
            let firstRouteSegment = this.$route.path.split("/")[1];
            if (this.$route.name === "immowert") {
                result["-motivwelt-wohnen"] = true;
            } else if (firstRouteSegment !== "berater") {
                result["-motivwelt-" + firstRouteSegment] = true;
            }
            return result;
        },
        loading() {
            return this.$store.state.loading;
        },
        error() {
            return this.$store.state.error;
        },
        messageCount() {
            let count = 0;
            for (let message in this.$store.state.postbox.all) {
                if (this.$store.state.postbox.all[message].Status == "UNREAD") {
                    count++;
                }
                // console.log(message);
            }
            // console.log(this.$store.state.postbox.all);
            return count;
        },
        isLoggedIn() {
            return this.$store.state.isLoggedIn;
        },
        askForRating() {
            return this.$store.state.askForRating;
        },
    },
    methods: {
        dismissAllLoadingInstances() {
            for (let loadingInstance of this.loadingInstances) {
                loadingInstance
                    .dismiss()
                    .then(() => {
                        // console.log("loading dismissed", response);
                        let currentIndex = this.loadingInstances.indexOf(
                            loadingInstance
                        );
                        this.loadingInstances.splice(currentIndex, 1);
                    })
                    .catch((error) => {
                        handleError(error);
                    });
            }
        },
        // dismissAllLoadings() {
        //   this.$ionic.loadingController
        //     .dismiss()
        //     .then(isDismissed => {
        //       if (isDismissed) {
        //         this.$ionic.loadingController.getTop().then(response => {
        //           setTimeout(() => {
        //             if (response !== undefined) {
        //               this.dismissAllLoadings();
        //             }
        //           }, 1000);
        //         });
        //       }
        //     })
        //     .catch(error => {
        //       handleError(error);
        //     });
        // },
        setupPushNotifications() {
            // Push Notifications for Magazin and Unwetter
            // UrbanAirshipPlugin.getDeeplink().then((response) => {
            //     if (
            //         "value" in response &&
            //         response.value !== "" &&
            //         response.value !== null
            //     ) {
            //         this.handleDeeplink(response.value);
            //     }
            // });
            window.addEventListener("deeplinkEvent", (e) => {
                // console.log(e);
                if (
                    "deeplink" in e &&
                    e.deeplink !== "" &&
                    e.deeplink !== null
                ) {
                    this.handleDeeplink(e.deeplink);
                }
            });
            // for (let key in this.$store.state.motivesConfig) {
            //     let motiveConfig = this.$store.state.motivesConfig[key];
            //     Storage.get({ key: motiveConfig.magazinTag }).then(
            //         ({ value: val }) => {
            //             if (val !== "false") {
            //                 UrbanAirshipPlugin.addPushNotificationTag({
            //                     tag: motiveConfig.magazinTag,
            //                 });
            //             }
            //         }
            //     );
            // }

            if (Capacitor.platform === "android") {
                // Push Notifications for Biketrax
                PushNotifications.createChannel({
                    id: "alarm",
                    name: "Alarm",
                    sound: "alarma.wav",
                    lightColor: "#FFFF0000", // red LED
                    importance: 5,
                    visibility: 1000,
                }).then(
                    () => {
                        // PushNotifications.listChannels().then(response => {
                        //     console.log(response);
                        // })
                    },
                    (error) => {
                        handleError(error);
                    }
                );
            }

            // Request permission to use push notifications
            // iOS will prompt user and return if they granted permission or not
            // Android will just grant without prompting
            PushNotifications.requestPermission().then((result) => {
                if (result.granted) {
                    // Register with Apple / Google to receive push via APNS/FCM
                    PushNotifications.register();
                } else {
                    // Show some error
                }
            });

            // On success, we should be able to receive notifications
            PushNotifications.addListener("registration", (token) => {
                this.$store.commit("setPushToken", token.value);
                // console.log(token.value);
                // alert("Push registration success, token: " + token.value);
            });

            // Some issue with our setup and push will not work
            PushNotifications.addListener("registrationError", (error) => {
                // alert("Error on registration: " + JSON.stringify(error));
                handleError(error);
            });

            // Show us the notification payload if the app is open on our device
            PushNotifications.addListener(
                "pushNotificationReceived",
                (notification) => {
                    // console.log("pushNotificationReceived", notification);
                    // alert("Push received: " + JSON.stringify(notification));
                    handleError(notification);
                }
            );

            // Method called when tapping on a notification
            PushNotifications.addListener(
                "pushNotificationActionPerformed",
                (notification) => {
                    // console.log("pushNotificationActionPerformed", notification);
                    // alert(
                    //     "Push action performed: " + JSON.stringify(notification)
                    // );
                    handleError(notification);
                }
            );
        },
        handleDeeplink(deeplink) {
            const url = new URL(deeplink);
            console.log(deeplink);
            console.log(url.pathname);
            console.log(url.hostname);
            if (url.pathname === "//magazin" || url.hostname === "magazin") {
                const browserUrl = url.searchParams.get("url");
                if (browserUrl !== null && browserUrl !== "") {
                    Browser.open({ url: browserUrl });
                }
            } else if (
                url.pathname === "//unwetterwarnung" ||
                url.hostname === "unwetterwarnung"
            ) {
                const unwettertext = url.searchParams.get("unwettertext");
                if (unwettertext !== null && unwettertext !== "") {
                    setTimeout(() => {
                        this.$ionic.alertController
                            .create({
                                header: "Unwetterwarnung",
                                message: unwettertext,
                                buttons: ["Verstanden"],
                            })
                            .then((a) => {
                                // console.log(a);
                                a.present();
                            });
                    }, 100);
                }
            } else if (
                url.pathname === "//biketrax" ||
                url.hostname === "biketrax"
            ) {
                const text = url.searchParams.get("text");
                if (text !== null && text !== "") {
                    setTimeout(() => {
                        this.$ionic.alertController
                            .create({
                                header: "BikeTrax Alarm",
                                message: text,
                                buttons: ["Verstanden"],
                            })
                            .then((a) => {
                                // console.log(a);
                                a.present();
                            });
                    }, 100);
                }
            } else if (url.pathname === "//seite" || url.hostname === "seite") {
                const link = url.searchParams.get("link");
                this.$router.push(link);
            } else if (
                url.pathname === "//seite-eingeloggt" ||
                url.hostname === "seite-eingeloggt"
            ) {
                const link = url.searchParams.get("link");
                console.log(link);
                isLoggedIn()
                    .then(() => {
                        this.$router.push(link);
                    })
                    .catch(() => {
                        this.$store.commit("setAfterLoginLink", link);
                        this.$router.push({
                            name: "login",
                        });
                    });
            }
        },
        ionTabsWillChange() {},
        openDokboxModal() {
            this.$ionic.modalController
                .create({
                    component: DokboxModal,
                    componentProps: {
                        propsData: {},
                        parent: this,
                    },
                    backdropDismiss: false,
                })
                .then((m) => m.present());
        },
        presentActionSheet() {
            return this.$ionic.actionSheetController
                .create({
                    buttons: [
                        // {
                        //     text: "Fotos & Dateien hochladen",
                        //     // icon: "document",
                        //     cssClass: "hochladen",

                        //     handler: () => {
                        //         this.openDokboxModal();
                        //     },
                        // },
                        {
                            text: "Schadensmeldung erstellen",
                            // icon: "car",
                            cssClass: "schadensmeldung",
                            handler: () => {
                                this.$router.push({ name: "schadensmeldung" });
                            },
                        },
                        {
                            text: "Berater kontaktieren",
                            // icon: "person",
                            cssClass: "berater",
                            handler: () => {
                                // this.$router.push("/berater");
                                this.$router.push({
                                    name: "berater",
                                    params: { directContact: true },
                                });
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
    },
};
</script>

<style lang="scss" scoped>
/* #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.ios {
    ion-tab-bar {
        ion-label {
            padding-bottom: 1px; // IOS LINEHEIGHT OVERFLOW FIX
        }
    }
}

ion-tab-bar {
    --color: var(--ion-color-medium-shade);
    --color-selected: var(--gangl-color-red);
    ion-label {
        font-size: x-small;
    }
}
ion-tab-button.-add-button ion-icon {
    border: solid 2px var(--ion-color-medium-shade);
    border-radius: 100px;
    margin: 0;
    font-size: x-large;
}

ion-tab-button [class^="icon-"],
[class*=" icon-"] {
    font-size: large;
    margin-bottom: 3px;
}

ion-badge {
    left: calc(50% + 6px);
    top: 8px;

    --background: var(--gangl-color-red);
    --color: #fff;
}
</style>

<style lang="scss">
.ios,
.md {
    .action-sheet-button {
        color: var(--ion-color-light-contrast);
        // font-size: 16px;
    }
}

.hochladen span {
    justify-content: start !important;
    text-align: left;
    &:before {
        content: "\e91f";
        font-family: "me1nsicons" !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-right: 20px;
        font-size: x-large;
    }
}

.schadensmeldung span {
    justify-content: start !important;
    text-align: left;
    &:before {
        content: "\e925";
        font-family: "me1nsicons" !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-right: 20px;
        font-size: x-large;
    }
}

.berater span {
    justify-content: start !important;
    text-align: left;
    &:before {
        content: "\e90b";
        font-family: "me1nsicons" !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin-right: 20px;
        font-size: x-large;
    }
}
</style>
